export default data => ({
    text: data.Texto,
    type: data.TipoMensaje.toLowerCase()
})